// Build-time constants only.
// All per-client settings (API URLs, branding, features, …) live in
// /_config/config.json on the server (or /assets/config.json for local dev).
// See __config/ in the project root for per-client reference files.
import { env } from './.env';

export const environment = {
  production: true,
  caching: false,
  basePath: '/assets',
  version: env['npm_package_version'],

  // Email debug — disabled in production by default
  email_debug: {
    enabled: false,
    test_email: '',
    redirect_all_emails: false,
  },
};
